import axios from "axios";
import moment from "moment";

export default {
  state: {
    allAddons: [],
    selectedAddons: [],
    selectedServices: [],
    isLoading: false,
    isLoadingNewPrice: false,
    pmsPackageError: false,
    pmsErrorConflict: false,
    addonsFailed: false,
    selectedAddon: null,
    error: null,
    payload: ""
  },
  mutations: {
    loadAddonsSuccess(state, payload) {
      state.allAddons = payload;
      state.isLoading = false;
    },
    setLoadAddonsFail(state, payload) {
      state.error = payload;
      state.addonsFailed = true;
      state.isLoading = false;
    },
    setPMSOrderConflict(state, payload){
      state.pmsErrorConflict = payload;
    },
    loadingAddons(state) {
      state.isLoading = true;
    },
    setSelectedAddon(state, payload) {
      state.selectedAddon = payload;
    },
    setAllAddons(state, payload) {
      state.allAddons = payload;
    },
    setSelectedAddons(state, payload) {
      state.selectedAddons = payload;
    },
    setPMSPackageError(state, payload) {
      state.pmsPackageError = payload;
    },
    setSelectedServices(state, payload) {
      state.selectedServices = payload;
    },
    loadNewPriceSuccess(state) {
      state.isLoadingNewPrice = false;
    },
    loadNewPriceFail(state, payload) {
      state.error = payload;
      state.isLoadingNewPrice = false;
    },
    loadingNewPrice(state) {
      state.isLoadingNewPrice = true;
    }
  },
  actions: {
    async LOAD_ADDONS({ commit, rootState }, { venueId, cartId, availabilityId, discountCode }) {
      commit("loadingAddons");
      try {
        let discountCodeParam = discountCode ? `&discount_code=${discountCode}` : ''

        let { data } = await axios.post(
          `${window.mp_url_settings["BASE_URL"]}/apiv2/catalog/index/${venueId}?order_id=${cartId}${discountCodeParam}`,
          {
            order_id: cartId,
            availability_id: availabilityId
          }
        );

        if(data == "package_pms_not_mapped"){
          commit('setPMSPackageError', true)
          commit("setLoadAddonsFail", data);
        }

        if(data == "temp_pms_order_error"){
          commit("setLoadAddonsFail", data);
        }

        if(data == "temp_pms_order_error_conflict"){
          commit("setPMSOrderConflict", true);
        }else{
          commit("setPMSOrderConflict", false);
        }

        // IMPORTANT
        // FETCH CATALOG ITEM PRICING HACK
        if(Array.isArray(data)){
          data = data.map(datum =>
            rootState.cart.has_intgr
              ? datum
              : {
                  ...datum,
                  price: datum.price * 100,
                  price_vat: datum.price_vat * 100
                }
          );  
          commit("loadAddonsSuccess", data);
        }
        return data;
      } catch (error) {
        commit("loadAddonsFail", error);
      }
    },
    SET_SELECTED_ADDONS({ commit }, { addons }) {
      commit("setSelectedAddons", addons);
    },
    SET_SELECTED_ADDON({ commit }, { addon }) {
      commit("setSelectedAddon", addon);
    },
    SET_SELECTED_SERVICES({ commit }, { addons }) {
      commit("setSelectedServices", addons);
    },
    async UPDATE_SELECTED_ITEM({ commit, state, rootState }, { cartId, row }) {
      commit("loadingNewPrice");
      try {
        let startDateTime = JSON.stringify(
          moment(
            `${moment(rootState.cart.events[0].start, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            )} ${row.service_time}`,
            "DD-MM-YYYY HH:mm"
          )
        );
        let endDateTime = JSON.stringify(
          moment(
            `${moment(rootState.cart.events[0].start, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            )} ${row.service_time_end}`,
            "DD-MM-YYYY HH:mm"
          )
        );

        let { data } = await axios.get(
          `${window.mp_url_settings["BASE_URL"]}/apiv2/cart/${cartId}/services/${row.id}?start_date_time=${startDateTime}&end_date_time=${endDateTime}&quantity=${row.quantity}`
        );

        // IMPORTANT
        // FETCH CATALOG ITEM PRICING HACK

        let newAllAddons = state.allAddons.map(addon =>
          addon.id === data.id && !rootState.cart.has_intgr
            ? {
                ...addon,
                price: data.price * 100,
                price_vat: data.price_vat * 100
              }
            : addon
        );
        commit("setAllAddons", newAllAddons);

        if (["misc", "services"].includes(row.type)) {
          let newSelectedServices = state.selectedServices.map(addon =>
            addon.id === data.id && !rootState.cart.has_intgr
              ? {
                  ...addon,
                  price: data.price * 100,
                  price_vat: data.price_vat * 100
                }
              : addon
          );
          commit("setSelectedServices", newSelectedServices);
        } else {
          let newSelectedAddons = state.selectedServices.map(addon =>
            addon.id === data.id && !rootState.cart.has_intgr
              ? {
                  ...addon,
                  price: data.price * 100,
                  price_vat: data.price_vat * 100
                }
              : addon
          );
          commit("setSelectedAddons", newSelectedAddons);
        }
        commit("loadNewPriceSuccess");
      } catch (error) {
        commit("loadNewPriceFail", error);
      }
    }
  }
};
